import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="state-dropdown"
export default class extends Controller {
	change(event) {
		const selectedState = event.target.options[event.target.selectedIndex].value;

		if (selectedState != '') {
			window.location.href = selectedState;
		}
	}
}
